exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".auditedmed h6{display:inline-block;margin-right:10px}.auditedmed h6:last-of-type{margin-right:0}.total-figures{display:inline-block;margin-right:20px;font-size:18px;float:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./client/app/common/reports/auditprogramdrgchanges/auditprogramdrgchanges.styl
// module id = 58
// module chunks = 1